import { QueueNowData, QueueTodayData, SegmentCustomer } from '../models/reports.external';
import { ICustomerInfo, IQueueReport, PartialReport } from '../models/reports.internal';
import { getTimestamp } from '../utils/timeUtils';
import getLwtStartTime from './getLwtStartTime';

const segmentCustomerToCustomerInfo = (customer?: SegmentCustomer): ICustomerInfo | null => customer
  ? {
    id: customer.id,
    name: [customer.firstName, customer.middleName, customer.lastName].filter(n => n !== '').join(' ') || 'Unknown',
    identifier: customer.phoneNumber || customer.emailAddress || '',
  }
  : null;

export function processQueueToday(queueToday: QueueTodayData): PartialReport<IQueueReport> {
  return {
    id: queueToday.id,
    slaThreshold: queueToday.sla,
    startOfToday: queueToday.startOfToday ? getTimestamp(queueToday.startOfToday) : null,
    queueTimedOutCount: queueToday.queueTimedOutCount,
    acceptedCount: queueToday.handledCount,
    abandonedCount: queueToday.abandonedCount,
    callbackRequestedCount: queueToday.callbackRequestedCount,
    callbackAcceptedCount: queueToday.callbackAcceptedCount,
    slaRatio: Math.max(queueToday.answeredWithinSLARatio, 0),
    longestWaitTimeInSeconds: queueToday.longestWaitTimeInSeconds,
    avgWaitingTimeInSeconds: queueToday.avgWaitingTimeInSeconds,
  };
}

export function processQueueNow(queueNow: QueueNowData): PartialReport<IQueueReport> {
  return {
    id: queueNow.id,
    name: queueNow.name || 'N/A', // for deleted queues
    workflowId: queueNow.workflowId,
    mediaGroup: queueNow.mediaGroup,
    lwtStart: getLwtStartTime(queueNow.queueSegments),
    callbackWaitingCount: queueNow.queueSegments.filter(s => s.virtualConversationType === 'Callback').length,
    conversationsWaiting: queueNow.queueSegments
      .map(qS => ({
        waitStartTime: getTimestamp(qS.queuedAt),
        position: qS.position,
        virtualConversationType: qS.virtualConversationType,
        customer: segmentCustomerToCustomerInfo(qS.customer),
      }))
      .sortBy(c => c.position),
    conversationsConnected: queueNow.agentSegments
      .map(aS => ({
        connectionStartTime: getTimestamp(aS.createdAt),
        virtualConversationType: aS.virtualConversationType,
        customer: segmentCustomerToCustomerInfo(aS.customer),
        agents: aS.agents,
      }))
      .sortBy(aS => aS.connectionStartTime),
  };
}